import React, { useEffect, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PageHeader from "../components/PageHeader";
import infoCircle from "../assets/info-circle.svg";
import TagInput from "../components/TagInput";
import { requestWithToken } from "../utils/apis";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import TinyMceEditor from "../components/TinyMceEditor";

const AddJob = () => {
  const navigate = useNavigate();
  const editorRef = useRef(null);

  const { jobId } = useParams();
  console.log(jobId, 'params')

  const formik = useFormik({
    initialValues: {
      position: "",
      slug: "",
      qualification: "",
      experiance: "",
      desc: "",
      skills: [],
      focus_keywords: [],
      metaTitle: "",
      metaDesc: "",
    },
    validationSchema: Yup.object({
      position: Yup.string().required("Opening Name is required"),
      slug: Yup.string()
        .matches(/^[a-z0-9-_]+$/, "Slug can only contain lowercase letters, numbers, hyphens, and underscores")
        .required("Slug is required"),
      skills: Yup.array().min(1, "At least one skill is required"),
      focus_keywords: Yup.array().min(1, "At least one focus keyword is required"),
      qualification: Yup.string().required("Qualifications are required"),
      experiance: Yup.string().required("Experience is required"),
      desc: Yup.string().required("Job Content is required"),
      metaTitle: Yup.string().required("SEO Title is required"),
      metaDesc: Yup.string().required("Meta Description is required"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const payload = {
          position: values.position,
          slug: values.slug,
          qualification: values.qualification,
          experiance: values.experiance,
          desc: values.desc,
          skills: values.skills.join(","),
          seo: {
            focus_keywords: values.focus_keywords.join(","),
            metaTitle: values.metaTitle,
            metaDesc: values.metaDesc,
          }
        }
        let response = null
        if (jobId) {
          response = await requestWithToken(
            "PUT",
            `/api/career/${jobId}`,
            payload
          );
        } else {
          response = await requestWithToken(
            "POST",
            "/api/career",
            payload
          );
        }
        if (response?.status === 200) {
          // console.log("Job submitted successfully:", response.data);
          navigate("/job-listing");
          resetForm();
          editorRef.current?.setContent("");// reset editor
        }

      } catch (error) {
        console.error("Error submitting job:", error);
        toast.error(error?.response?.data?.message || "Something went wrong. Please try again.");
      } finally {
        setSubmitting(false);
      }
    },
  });

 
  const fetchDetails = async (id) => {
    try {
      const response = await requestWithToken("GET", `/api/career/detail/${id}`);
      if (response?.status === 200) {
        const job = response.data.data;
        formik.setValues({
          position: job.position || "",
          slug: job.slug || "",
          qualification: job.qualification || "",
          experiance: job.experiance || "",
          desc: job.desc || "",
          skills: job.skills ? job.skills.split(",") : [],
          focus_keywords: job.seo?.focus_keywords ? job.seo.focus_keywords.split(",") : [],
          metaTitle: job.seo?.metaTitle || "",
          metaDesc: job.seo?.metaDesc || "",
        });
        formik.setFieldValue("desc", job.desc || "");
      }
    } catch (error) {
      console.error("Error fetching job details:", error);
      toast.error("Failed to fetch job details");
    }
  }

  useEffect(() => {
    if (jobId) {
      fetchDetails(jobId);
    }
  }
    , [jobId]);
  return (
    <>
      <PageHeader pageTitle={jobId ? "Job Details" : "Add New Job"}>
        <button
          className="btn-black"
          onClick={formik.handleSubmit}
          disabled={formik.isSubmitting}
        >
          {formik.isSubmitting ? <Spinner size="sm" /> : (jobId ? "Update" : "Publish")}
        </button>
      </PageHeader>

      <div className="page-container">
        <div className="add-blog-form">
          <div className="row">
            {/* Left Section */}
            <div className="col-md-8 d-flex flex-column">
              <div className="theme-card p-3 mb-3 h-100">
                {/* Skills */}
                <div className="frm-group">
                  <label className="frm-label">Skills Required</label>
                  <div className="tag-card">
                    <TagInput
                      value={formik.values.skills}
                      onChange={(tags) =>
                        formik.setFieldValue("skills", tags)
                      }
                    />
                    {formik.touched.skills && formik.errors.skills && (
                      <div className="input-error">{formik.errors.skills}</div>
                    )}
                  </div>
                </div>

                {/* Qualifications */}
                <div className="frm-group">
                  <label className="frm-label">Qualifications</label>
                  <input
                    type="text"
                    name="qualification"
                    className="frm-input"
                    placeholder="Enter Qualifications Here..."
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.qualification}
                  />
                  {formik.touched.qualification &&
                    formik.errors.qualification && (
                      <div className="input-error">
                        {formik.errors.qualification}
                      </div>
                    )}
                </div>

                {/* Experience */}
                <div className="frm-group">
                  <label className="frm-label d-flex align-items-center">
                    Experience
                    <img
                      className="ms-2"
                      src={infoCircle}
                      alt="Info"
                      title="Add Experience eg. 4.5 years"
                    />
                  </label>
                  <input
                    type="text"
                    name="experiance"
                    className="frm-input"
                    placeholder="Enter Experience Here..."
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.experiance}
                  />
                  {formik.touched.experiance && formik.errors.experiance && (
                    <div className="input-error">
                      {formik.errors.experiance}
                    </div>
                  )}
                </div>

                {/* Job Content (TinyMce) */}
                <div className="frm-group h-100 d-flex flex-column mb-0">
                  <label className="frm-label">About the Job</label>
                  <div className="tinymce-wrapper-news">
                    <TinyMceEditor
                      value={formik.values.content}
                      editorRef={editorRef}
                      height="100%"
                      onChange={(content) => {
                        formik.setFieldValue("content", content);
                      }}
                    />
                  </div>
                  {formik.touched.desc && formik.errors.desc && (
                    <div className="input-error">
                      {formik.errors.desc}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Right Section */}
            <div className="col-md-4 position-relative">
              <div className="right-sec">
                {/* General Details */}
                <div className="theme-card p-4 mb-3">
                  <div className="card-title pb-3">General Details</div>

                  {/* Opening Name */}
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      Opening Name
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add Opening Name eg. Manager"
                      />
                    </label>
                    <input
                      type="text"
                      name="position"
                      className="frm-input"
                      placeholder="Enter Opening Name eg. Manager"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.position}
                    />
                    {formik.touched.position &&
                      formik.errors.position && (
                        <div className="input-error">
                          {formik.errors.position}
                        </div>
                      )}
                  </div>

                  {/* Slug */}
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      Slug
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add Slug name of Opening"
                      />
                    </label>
                    <input
                      type="text"
                      name="slug"
                      className="frm-input"
                      placeholder="Slug name eg. manager"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.slug}
                    />
                    {formik.touched.slug && formik.errors.slug && (
                      <div className="input-error">{formik.errors.slug}</div>
                    )}
                  </div>
                </div>

                {/* SEO Section */}
                <div className="theme-card p-4 mb-3">
                  <div className="card-title pb-3">SEO</div>

                  {/* Focus Keywords */}
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      Focus Keywords
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add Keywords"
                      />
                    </label>
                    <div className="tag-card">
                      <TagInput
                        value={formik.values.focus_keywords}
                        onChange={(tags) =>
                          formik.setFieldValue("focus_keywords", tags)
                        }
                      />
                      {formik.touched.focus_keywords &&
                        formik.errors.focus_keywords && (
                          <div className="input-error">
                            {formik.errors.focus_keywords}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* SEO Title */}
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      SEO Title
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add SEO Title"
                      />
                    </label>
                    <input
                      type="text"
                      name="metaTitle"
                      className="frm-input"
                      placeholder="Enter SEO title"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.metaTitle}
                    />
                    {formik.touched.metaTitle && formik.errors.metaTitle && (
                      <div className="input-error">
                        {formik.errors.metaTitle}
                      </div>
                    )}
                  </div>

                  {/* Meta Description */}
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      Meta Description
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add Meta Description"
                      />
                    </label>
                    <textarea
                      name="metaDesc"
                      className="frm-input"
                      rows={3}
                      placeholder="Enter Meta Description"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.metaDesc}
                    />
                    {formik.touched.metaDesc &&
                      formik.errors.metaDesc && (
                        <div className="input-error">
                          {formik.errors.metaDesc}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
            {/* End Right Section */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddJob;
